import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";
import { BaseTableLayout } from "../../components/base-table-layout";
import { TableFilterPopover } from "../../components/table-filter-popover";
import { useTableFilters } from "../../hooks/use-table-filters";
import { TableRow } from "../../utils/tables-metadata";
import { DiagnosticReportRowData } from "./diagnostic-reports-rows";
import { useNotesColumns, useNotesFilterOptions } from "./notes-shared";

export type BrowseNotesTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  displayName: string;
  onPdfView?: (docId: string) => void;
  isRowViewed?: (row: TableRow) => boolean;
};

/**
 * Notes table component for browse mode.
 * Uses BaseTableLayout with standard table styling.
 * Parent provides the card wrapper.
 */
export function BrowseNotesTable({
  rows,
  onRowClick,
  filterQuery,
  displayName,
  isRowViewed,
}: BrowseNotesTableProps) {
  const ehrContext = useEhrContext();
  const columns = useNotesColumns(ehrContext);
  const filterOptions = useNotesFilterOptions(rows);

  const { activeFilters, setActiveFilters, filteredRows } = useTableFilters(rows, filterOptions);

  function handleRowClick(row: DiagnosticReportRowData) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={filteredRows as DiagnosticReportRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
      headerActionsSlot={
        filterOptions.length > 0 ? (
          <TableFilterPopover
            filters={filterOptions}
            activeFilters={activeFilters}
            setActiveFilters={newFilters => setActiveFilters(newFilters)}
          />
        ) : undefined
      }
    />
  );
}
